const getters = {
    // 计算属性和computed是一样的道理
    countAddSix(state){
     return state.count+5
    }
  }
export default getters